/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * PrevArrowIcon - Auto-generated from icon.js
 */
export const PrevArrowIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g filter="url(#filter0_d_518_190)">
			<path d="M7.99875 12.989C7.99829 12.7558 8.07967 12.5297 8.22875 12.3501L13.2287 6.36062C13.3985 6.15676 13.6424 6.02856 13.9068 6.00422C14.1713 5.97989 14.4345 6.06141 14.6387 6.23085C14.843 6.40029 14.9714 6.64378 14.9958 6.90774C15.0201 7.1717 14.9385 7.43452 14.7687 7.63838L10.2887 12.989L14.6087 18.3397C14.6918 18.4418 14.7538 18.5593 14.7913 18.6854C14.8287 18.8115 14.8408 18.9438 14.8269 19.0746C14.8129 19.2054 14.7732 19.3321 14.7101 19.4475C14.6469 19.563 14.5615 19.6648 14.4587 19.7472C14.3559 19.8386 14.2353 19.9079 14.1044 19.9506C13.9736 19.9933 13.8353 20.0086 13.6982 19.9954C13.5611 19.9823 13.4283 19.9411 13.3079 19.8743C13.1875 19.8076 13.0823 19.7167 12.9987 19.6074L8.16875 13.6179C8.04323 13.4332 7.98338 13.2117 7.99875 12.989Z" fill="white" />
		</g>
		<defs>
			<filter id="filter0_d_518_190" x="-0.00361824" y="-2" width="23.0036" height="30" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
				<feOffset />
				<feGaussianBlur stdDeviation="4" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_518_190" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_518_190" result="shape" />
			</filter>
		</defs>
	</svg>
);

export default PrevArrowIcon;
